export default __webpack_public_path__ + "static/media/logout-red.91249a77.svg";